import { CascaderOption } from '../model/common-type';

export const HD_CASCADER_MENU_CLASS = 'hd-cascader-menus';

export function cascaderPinyinFilter(
  inputValue: string,
  path: any[],
  pinyinField: string = 'pinyin'
): boolean {
  if (!inputValue) {
    return true;
  }
  const keyword = inputValue.trim().toLowerCase();
  return path.some((option) => {
    const label =
      option.label != null ? String(option.label).toLowerCase() : '';
    const value =
      option.value != null ? String(option.value).toLowerCase() : '';
    const pinyin =
      option[pinyinField] != null
        ? String(option[pinyinField]).toLowerCase()
        : '';
    return (
      (label && label.indexOf(keyword) !== -1) ||
      (value && value.indexOf(keyword) !== -1) ||
      (pinyin && pinyin.indexOf(keyword) !== -1)
    );
  });
}

export function getCascaderShowSearch(
  cascaderOption?: CascaderOption
): boolean | { filter?: Function; sorter?: Function } {
  if (!cascaderOption) {
    return true;
  }
  if (cascaderOption.showSearch === false) {
    return false;
  }
  if (
    cascaderOption.showSearch &&
    typeof cascaderOption.showSearch === 'object'
  ) {
    return cascaderOption.showSearch;
  }
  const pinyinField = cascaderOption.pinyinField || 'pinyin';
  return {
    filter: (inputValue: string, path: any[]) =>
      cascaderPinyinFilter(inputValue, path, pinyinField),
  };
}

/** 下拉菜单 class：默认带 hd-cascader-menus，便于搜索结果按内容撑开 */
export function getCascaderMenuClassName(
  cascaderOption?: CascaderOption
): string {
  const custom =
    cascaderOption && cascaderOption.menuClassName
      ? String(cascaderOption.menuClassName).trim()
      : '';
  if (!custom) {
    return HD_CASCADER_MENU_CLASS;
  }
  if (custom.indexOf(HD_CASCADER_MENU_CLASS) !== -1) {
    return custom;
  }
  return HD_CASCADER_MENU_CLASS + ' ' + custom;
}

/**
 * 合并 menuStyle。
 * 默认不强制宽度；仅当配置了 dropdownMinWidth / menuStyle 时才写入。
 */
export function getCascaderMenuStyle(
  cascaderOption?: CascaderOption
): { [key: string]: string } | null {
  if (!cascaderOption) {
    return null;
  }
  const style: { [key: string]: string } = {};
  if (cascaderOption.menuStyle) {
    Object.keys(cascaderOption.menuStyle).forEach((key) => {
      style[key] = cascaderOption.menuStyle[key];
    });
  }
  if (cascaderOption.dropdownMinWidth != null) {
    const minWidthCss =
      typeof cascaderOption.dropdownMinWidth === 'number'
        ? cascaderOption.dropdownMinWidth + 'px'
        : String(cascaderOption.dropdownMinWidth);
    if (style['--hd-cascader-menu-min-width'] == null) {
      style['--hd-cascader-menu-min-width'] = minWidthCss;
    }
  }
  return Object.keys(style).length ? style : null;
}
